import { supabase } from '@/lib/supabase'

export type RoleInOutPolicy = {
  role: string
  inout_enabled: boolean
}

export type PlanInOutPolicy = {
  plan_id: string
  inout_enabled: boolean
}

export async function fetchRoleInOutPolicies(): Promise<RoleInOutPolicy[]> {
  const { data, error } = await supabase
    .from('role_inout_policies')
    .select('role,inout_enabled')
    .order('role', { ascending: true })

  if (error) throw error
  return (data || []) as RoleInOutPolicy[]
}

export async function upsertRoleInOutPolicy(role: string, enabled: boolean): Promise<void> {
  const { error } = await supabase
    .from('role_inout_policies')
    .upsert({ role, inout_enabled: enabled }, { onConflict: 'role' })

  if (error) throw error
}

export async function fetchPlanInOutPolicies(): Promise<PlanInOutPolicy[]> {
  const { data, error } = await supabase
    .from('plan_inout_policies')
    .select('plan_id,inout_enabled')
    .order('plan_id', { ascending: true })

  if (error) throw error
  return (data || []) as PlanInOutPolicy[]
}

export async function upsertPlanInOutPolicy(planId: string, enabled: boolean): Promise<void> {
  const { error } = await supabase
    .from('plan_inout_policies')
    .upsert({ plan_id: planId, inout_enabled: enabled }, { onConflict: 'plan_id' })

  if (error) throw error
}

